const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class FreedomOfMovement extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.FreedomOfMovement,
            "Each civilzation may mvoe one of their workers from one technology card to another. If the new location has a night resource cost, the difference must be paid.",
            {}
        )
    }
}

module.exports = FreedomOfMovement;